import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormGroup, FormBuilder, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Provider } from 'app/core/models/provider.model';
import { ProviderService } from 'app/core/services/provider.service';
import { Client } from 'app/core/models/client.model';
import { NavigationService } from 'app/core/services/navigation.service';
import { ClientsService } from 'app/core/services/clients.service';
import { mapObjectToFormGroup, applyServerErrorsToFormGroup } from 'app/core/lib/form-utils';
import { filterProviderStatusOptions } from 'app/core/options/provider-status.opts';
import { providerCredentialOptions } from 'app/core/options/provider-credential.opts';
import { ProviderStatus } from 'app/core/enums/provider-status.enum';
import { ProviderSpecialty } from 'app/core/models/provider-specialty.model';
import { ProviderSpecialtyService } from 'app/core/services/provider-specialty.service';
import { FormControlValidityClassDirective } from '../../../shared/directives/form-control-validity-class.directive';
import { FormControlServerErrorsComponent } from '../../../shared/components/form-control-server-errors/form-control-server-errors.component';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-capture-admin-provider-new',
    styleUrls: ['./capture-admin-provider-new.component.scss'],
    templateUrl: './capture-admin-provider-new.component.html',
    imports: [FormsModule,
              ReactiveFormsModule,
              FormControlValidityClassDirective,
              FormControlServerErrorsComponent,
              NgSelectComponent]
})
export class CaptureAdminProviderNewComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private providerService = inject(ProviderService);
  private providerSpecialtyService = inject(ProviderSpecialtyService);
  private navigationService = inject(NavigationService);
  private clientsService = inject(ClientsService);

  formGroup: FormGroup;
  saving = false;
  clients: Client[];
  providerSpecialties: ProviderSpecialty[] = [];
  providerCredentialOptions = providerCredentialOptions;
  providerStatusOptions;

  @ViewChild('form') public form: FormGroupDirective;

  ngOnInit() {
    const queryParams = this.navigationService.queryParams;

    const provider = new Provider;
    provider.npi = provider.npi || queryParams.npi;
    provider.status = ProviderStatus.new;

    this.formGroup = mapObjectToFormGroup(this.formBuilder, provider, [
      'first',
      'last',
      'npi',
      'status',
      'credentials',
      'specialties',
      'internalNotes',
      'note',
    ]);

    this.providerStatusOptions = filterProviderStatusOptions(ProviderStatus.new);

    this.clientsService.getList(null, { applicableToReferralClaims: true }).subscribe(result => {
      this.clients = result.clients;
    });

    this.providerSpecialtyService.getList().subscribe(({ providerSpecialties }) => {
      this.providerSpecialties = providerSpecialties;
    });
  }

  onSubmit() {
    this.saving = true;

    this.providerService.create(this.formGroup.value).subscribe(
      provider => this.handleSaveSuccess(provider),
      error => this.handleSaveFailure(error)
    );
  }

  onCancelClick() {
    this.navigationService.navigateTo(`/capture-admin/providers/all`);
  }

  private handleSaveSuccess(provider: Provider) {
    this.navigationService.navigateTo(`/capture-admin/providers/${provider.npi}`);
  }

  private handleSaveFailure(response: HttpErrorResponse) {
    this.saving = false;

    if (response.status === 400) {
      applyServerErrorsToFormGroup(response, this.formGroup);
    } else {
      console.error(response);
    }
  }
}
